/**
 * FIXME: we are currently investigation an issue with circular dependencies and jest.
 * All these imports should use the `public` folder from each module but it is causing
 * a few tests to fail due to a circular dependency problem.
 */
import { DataSourceDefinition, RecordType } from '@factorialco/f0-react'

import { navigation as aiReports } from 'modules/ai_reports/lib/navigation'
import { navigation as analytics } from 'modules/analytics/lib/navigation'
import { navigation as approvals } from 'modules/approvals/lib/navigation'
import { careersNavigation as careers } from 'modules/ats/lib/careersNavigation'
import { navigation as ats } from 'modules/ats/lib/navigation'
import { navigation as hiringTool } from 'modules/ats_hiring_tool/lib/navigation'
import { navigation as clockIn } from 'modules/attendance/lib/navigation/clockIn'
import { navigation as timeTracking } from 'modules/attendance/lib/navigation/timeTracking'
import { navigation as authentication } from 'modules/authentication/lib/navigation'
import { navigation as myBenefits } from 'modules/benefits/lib/myBenefitsNavigation'
import { navigation as benefits } from 'modules/benefits/lib/navigation'
import { navigation as upgradePlan } from 'modules/billing/lib/navigation'
import { navigation as bookkeepers } from 'modules/bookkeepers/lib/navigation'
import { navigation as calendar } from 'modules/calendar/lib/navigation'
import { navigation as compensations } from 'modules/compensations/lib/navigation'
import { navigation as competencies } from 'modules/competencies/lib/navigation'
import { navigation as complaints } from 'modules/complaints/lib/navigation'
import { navigation as dashboard } from 'modules/dashboard/lib/navigation'
import { navigation as discover } from 'modules/discover/lib/navigation'
import { filesNavigation as files } from 'modules/documents/lib/filesNavigation'
import { navigation as documents } from 'modules/documents/lib/navigation'
import { navigation as employeeLifecycle } from 'modules/employee_lifecycle/lib/navigation'
import { navigation as employee_onboarding } from 'modules/employee_onboarding/lib/navigation'
import { navigation as employees } from 'modules/employees/lib/navigation'
import { navigation as engagement } from 'modules/engagement/lib/navigation'
import { expensesNavigation as expenses } from 'modules/expenses/lib/navigation'
import { myCards, myExpenses } from 'modules/expenses/lib/navigationMy'
import { navigation as finance, mySpending } from 'modules/finance/lib/navigation'
import { navigation as goals } from 'modules/goals/lib/navigation'
import { navigation as insights } from 'modules/insights/lib/navigation'
import { navigation as deviceCatalog } from 'modules/it_management/lib/deviceCatalogNavigation'
import { navigation as it_management } from 'modules/it_management/lib/navigation'
import { navigation as kudos } from 'modules/kudos/lib/navigation'
import { navigation as marketplaceModules } from 'modules/marketplace_modules/lib/navigation'
import { navigation as myPayroll } from 'modules/my_payroll/lib/navigation'
import { navigation as inbox } from 'modules/notifications/lib/navigation'
import { navigation as nps } from 'modules/nps/lib/navigation'
import { navigation as onboarding } from 'modules/onboarding/lib/navigation'
import { navigation as performanceOneOnOnes } from 'modules/one_on_ones/lib/navigation'
import { navigation as pages } from 'modules/pages/lib/navigation'
import { navigation as payrollBundle } from 'modules/payroll_bundle/lib/navigation'
import { navigation as talentAnalytics } from 'modules/performance_analytics/lib/navigation'
import { navigation as performanceCycles } from 'modules/performance_cycles/lib/navigation'
import { navigation as performanceFeedbacks } from 'modules/performance_feedbacks/lib/navigation'
import { navigation as performanceGoals } from 'modules/performance_goals/lib/navigation'
import { navigation as performanceProcess } from 'modules/performance_process/lib/navigation'
import { navigation as playground } from 'modules/playground/lib/navigation'
import { navigation as communities } from 'modules/posts/lib/navigation'
import { navigation as processes } from 'modules/processes/lib/navigation'
import { navigation as procurement } from 'modules/procurement/lib/navigation'
import { navigation as myPurchases } from 'modules/procurement/lib/navigationMy'
import {
  autoOnboarding,
  factorialOneNavigation as factorialOne,
  productUpdatesNavigation as productUpdates,
} from 'modules/product_updates/lib/navigation'
import { navigation as profile } from 'modules/profile/lib/navigation'
import { navigation as myProjects } from 'modules/project_management/lib/myProjectsNavigation'
import { navigation as projects } from 'modules/project_management/lib/navigation'
import { navigation as referralProgram } from 'modules/referral_program/lib/navigation'
import { navigation as reports } from 'modules/reports/lib/navigation'
import { navigation as salaryAdvance } from 'modules/salary_advance/lib/navigation'
import { navigation as settings } from 'modules/settings/lib/navigation'
import { navigation as shifts } from 'modules/shift_management/lib/navigation'
import { navigation as software } from 'modules/software_management/lib/navigation'
import { navigation as spaceControl } from 'modules/space_control/lib/navigation'
import { navigation as tasks } from 'modules/tasks/lib/navigation'
import { navigation as timeCategoriesSettings } from 'modules/time_categories_settings/lib/navigation'
import { navigation as timeOff } from 'modules/timeoff/lib/navigation'
import { navigation as myTrainings } from 'modules/trainings/lib/myTrainingsNavigation'
import { navigation as trainings } from 'modules/trainings/lib/navigation'
import { upgradeLegacyNavigation as upgradeLegacy } from 'modules/upsell/lib/navigation'
import { navigation as workflows } from 'modules/workflows/lib/navigation'

import type { Location, SiblingsNavigationSelectFromSource } from './types'

export const navigation = {
  path: '/',
  children: {
    approvals,
    benefits,
    dashboard,
    profile,
    timeTracking,
    clockIn,
    myProjects,
    projects,
    timeOff,
    timeCategoriesSettings,
    tasks,
    documents,
    myBenefits,
    myExpenses,
    myCards,
    mySpending,
    employees,
    employee_onboarding,
    employeeLifecycle,
    calendar,
    communities,
    competencies,
    compensations,
    complaints,
    ats,
    authentication,
    hiringTool,
    performanceProcess,
    talentAnalytics,
    engagement,
    reports,
    aiReports,
    processes,
    expenses,
    payrollBundle,
    files,
    shifts,
    bookkeepers,
    careers,
    finance,
    software,
    pages,
    logout: {
      path: 'logout',
    } as const,
    inbox,
    personalSettings: {
      path: 'personal-settings',
    } as const,
    upgradePlan,
    settings,
    spaceControl,
    deviceCatalog,
    it_management,
    trainings,
    myPayroll,
    myTrainings,
    notFound: {
      path: '*',
    } as const,
    autoOnboarding,
    insights,
    onboarding,
    analytics,
    playground,
    referralProgram,
    salaryAdvance,
    kudos,
    productUpdates,
    factorialOne,
    marketplaceModules,
    upgradeLegacy,
    performanceCycles,
    goals,
    performanceGoals,
    performanceFeedbacks,
    performanceOneOnOnes,
    procurement,
    myPurchases,
    nps,
    discover,
    workflows,
  },
} satisfies Location

export const createBreadcrumbSelectDefinition = <
  T extends RecordType,
  S extends Omit<DataSourceDefinition<T>, 'dataAdapter'>
>(
  breadcrumbSelect: SiblingsNavigationSelectFromSource<T, S>
): SiblingsNavigationSelectFromSource<T, S> => {
  return {
    ...breadcrumbSelect,
    mapOptions: (data: T) => breadcrumbSelect.mapOptions(data),
  }
}
